import { Property } from "../../../global/types";

export interface MapBounds {
  NE: { lat: number; lng: number };
  SW: { lat: number; lng: number };
}

export function isPropertyInBounds(
  propertyLat: number | string,
  propertyLng: number | string,
  bounds: MapBounds
): boolean {
  const lat = typeof propertyLat === "string" ? parseFloat(propertyLat) : propertyLat;
  const lng = typeof propertyLng === "string" ? parseFloat(propertyLng) : propertyLng;

  if (Number.isNaN(lat) || Number.isNaN(lng)) {
    return false;
  }

  const eastBound = lng < bounds.NE.lng;
  const westBound = lng > bounds.SW.lng;
  let inLong: boolean;

  if (bounds.NE.lng < bounds.SW.lng) {
    inLong = eastBound || westBound;
  } else {
    inLong = eastBound && westBound;
  }

  const inLat = lat > bounds.SW.lat && lat < bounds.NE.lat;
  return inLat && inLong;
}

export function filterPropertiesByBounds(
  properties: Property[],
  bounds: MapBounds | null
): Property[] {
  if (!bounds) {
    return properties;
  }

  return properties.filter((property) =>
    isPropertyInBounds(
      property.address.latitude,
      property.address.longitude,
      bounds
    )
  );
}
